import { createAction } from "redux-act";

export const ShowContextMenuAction = createAction("Context Menu - Show");
export const HideContextMenuAction = createAction("Context Menu - Hide");
